const kStorageKey = "trafficSource";

/// Tag the budget2027 microsite puts on its outbound luminews.my links.
export const kBudget2027Source = "budget2027";

/// Remembers the landing `utm_source` for this tab, so pages reached by
/// in-site navigation — which drops the query string — can still tailor UI.
/// sessionStorage throws in private mode and with site data blocked, so both
/// halves are guarded and a failure just means the default experience.
export function rememberTrafficSource(search: string) {
  const source = new URLSearchParams(search).get("utm_source");
  if (!source) return;
  try {
    sessionStorage.setItem(kStorageKey, source);
  } catch {}
}

export function getTrafficSource(): string | null {
  try {
    return sessionStorage.getItem(kStorageKey);
  } catch {
    return null;
  }
}
